
(function (angular) {

	angular.module('slider', []);

})(angular);
